<div
  class="input-group"
  [ngClass]="props.inputClass"
  [class.is-invalid]="showError"
  [class.disabled]="formControl.disabled"
  >
  @if (props.addonStart) {
    <span
      class="input-group-text"
      [ngClass]="props.addonStartClass"
      >
      {{ props.addonStart }}
    </span>
  }

  <input
    type="text"
    class="form-control form-control-lg"
    [formControl]="formControl"
    [placeholder]="props.placeholder"
    [formlyAttributes]="field"
    mask="separator.0"
    thousandSeparator=","
    [attr.data-testid]="props.testId || field.key"
    [class.is-invalid]="showError"
    [class.is-valid]="(formControl.dirty || formControl.touched) && !showError"
    currencyMask
    />

  @if (props.addonEnd) {
    <span
      class="input-group-text"
      [ngClass]="props.addonEndClass"
      >
      {{ props.addonEnd }}
    </span>
  }
</div>

@if (showError && !props.suppressErrors) {
  <div class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
    <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
    <formly-validation-message class="ms-3" [id]="id + '-error-description-id'" [field]="field"></formly-validation-message>
  </div>
}
